import { useRouter } from 'next/router'
import {
  demoAliasConstant,
  demoAliasQueryConstant,
} from 'components/Ielts/IeltsOnboardingForms/utils'

const useDemoAlias = () => {
  const router = useRouter()
  const demoAliasQuery = router.query[demoAliasQueryConstant] as string
  const isMasterclassAlias = demoAliasQuery == demoAliasConstant['masterclass']

  const appendMasterclassAliasToQueryParams = (url: string) => {
    if (!isMasterclassAlias) return url
    const aliasUrl = `${demoAliasQueryConstant}=${demoAliasConstant.masterclass}`
    return url.includes('?') ? `${url}&${aliasUrl}` : `${url}?${aliasUrl}`
  }

  return {
    isMasterclassAlias,
    appendMasterclassAliasToQueryParams,
  }
}
export default useDemoAlias
